var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"elImg",attrs:{"id":"elImg","src":_vm.imgUrl,"preview-src-list":_vm.srcList}})}
var staticRenderFns = []

export { render, staticRenderFns }